import { useLayoutEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { subscribeDevice } from '@/utils/pushManager';

const LoginThrough = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useLayoutEffect(() => {
    const accessToken = searchParams.get('accessToken');
    const redirect = searchParams.get('redirect');

    if (accessToken) {
      localStorage.setItem('authorizationToken', accessToken);
      subscribeDevice();
      navigate(redirect || '/');
    } else {
      navigate('/user-login');
    }
  }, []);

  return <></>;
};

export default LoginThrough;
